<template>
  <div class="app-personal-data-form">
      <b-row class="salution">
        <b-col md="" cols="12" class="label">
          <slot name="lblSalutation"> Anrede</slot>
        </b-col>
        <b-col md="" cols="12" class="value">{{currentCustomer.salutation}}</b-col>
      </b-row>
      <b-row class="lastName">
        <b-col md="" cols="12" class="label">
          <slot name="lblLastName">Nachname</slot>
        </b-col>
        <b-col md="" cols="12" class="value">{{currentCustomer.lastName}}</b-col>
      </b-row>
      <b-row class="firstName">
        <b-col md="" cols="12" class="label">
          <slot name="lblFirstName">Vorname</slot>
        </b-col>
        <b-col md="" cols="12" class="value">{{currentCustomer.firstName}}</b-col>
      </b-row>
      <b-form-group class="street-group">
        <b-row class="streetNumber">
          <b-col md="" cols="12" class="label">
            <label class="mandatory">  <slot name="lblStreetNumber">Straße / Hausnr.</slot></label>
          </b-col>
          <b-col md="" cols="12" class="street">
            <b-form-input
              name="street"
              type="text"
              v-model="currentCustomer_.address.street"
              required
              @input="$v.currentCustomer.address.street.$touch"
              :state="isValid('street','address','currentCustomer')"
            ></b-form-input>
          </b-col>
          <b-col md="" cols="12" class="houseNumber">
            <b-form-input
              name="houseNumber"
              type="text"
              v-model="currentCustomer_.address.houseNumber"
              required
              @input="$v.currentCustomer.address.houseNumber.$touch"
              :state="isValid('houseNumber','address','currentCustomer')"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="zip-group">
        <b-row class="zipCity">
          <b-col md="" cols="12" class="label">
            <label class="mandatory"><slot name="lblZipCity">PLZ / Ort</slot></label>
          </b-col>
          <b-col md="" cols="12" class="zip">
            <b-form-input
              name="zip"
              type="text"
              v-model="currentCustomer_.address.zip"
              required
              @input="$v.currentCustomer.address.zip.$touch"
              :state="isValid('zip', 'address','currentCustomer')"
            ></b-form-input>
          </b-col>
          <b-col md="" cols="12" class="city">
            <b-form-input
              name="city"
              type="text"
              v-model="currentCustomer_.address.city"
              required
              @input="$v.currentCustomer.address.city.$touch"
              :state="isValid('city', 'address','currentCustomer')"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="supplement-group">
        <b-row class="supplement">
          <b-col md="" cols="12" class="label">
            <label><slot name="lblSupplement">Adresszusatz</slot></label>
          </b-col>
          <b-col md="" cols="12">
            <b-form-input
              name="supplement"
              type="text"
              v-model="currentCustomer_.address.supplement"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-row class="birthDate">
        <b-col md="" cols="12" class="label">
          <slot name="lblBirthDate">Geburtsdatum</slot>
        </b-col>
        <b-col md="" cols="12" class="value">{{currentCustomer.birthDate}}</b-col>
      </b-row>
  </div>
</template>

<script>
import { BFormInput, BRow, BCol, BFormGroup } from 'bootstrap-vue'
import { validationMixin } from 'vuelidate'
import isValid from '../../../../mixins/isValid'
import { validZipCode, validCityString } from '@/validators/address'
import syncProperty from '@/mixins/syncProperty'
import { required } from 'vuelidate/lib/validators'
import slotProxy from '@/mixins/slotProxy'
export const stepName = 'changePersonalData'
export default {
  name: 'PersonalDataForm',
  components: {
    BFormInput,
    BRow,
    BCol,
    BFormGroup
  },
  methods: {
  },
  watch: {
    '$v.$invalid': {
      immediate: true,
      handler: function (newValue) {
        this.$emit('update:invalid', newValue)
      }
    }
  },
  mixins: [
    validationMixin,
    isValid,
    slotProxy(),
    syncProperty('currentCustomer', 'currentCustomer_')
  ],
  validations () {
    return {
      currentCustomer: {
        address: {
          street: {
            required
          },
          houseNumber: {
            required
          },
          zip: {
            validZipCode,
            required
          },
          city: {
            validCityString,
            required
          }
        }
      }
    }
  }
}
</script>
